import moment from "moment";
class Groups {
  constructor(id, from, to, segmentId, segementDesploy, segmentName, name) {
    this.id = id;
    this.from = from;
    this.to = to;
    this.segmentId = segmentId;
    this.segementDesploy = segementDesploy;
    this.segmentName = segmentName;
    this.name = name;
    this.formattedDesde = moment(from, "YYYY-MM-DD").format("DD-MM-YYYY");
    this.formattedHasta =
      to !== null ? moment(to, "YYYY-MM-DD").format("DD-MM-YYYY") : "";
  }

  static fromJson({
    grupoId,
    fecDesde,
    fecHasta,
    segmId,
    segmDespl,
    segmNombre,
    grpNombre,
  }) {
    return new Groups(
      grupoId,
      fecDesde,
      fecHasta,
      segmId,
      segmDespl,
      segmNombre,
      grpNombre
    );
  }
}

export default Groups;
